import PricingCard from "../Card/PricingCard";
export default function PricingOption() {
  const plans = [
    {
      title: (
        <>
          Download Online courses onto your school or institution's LMS for the
          school or institution students only. <br /> <br /> 
          <span className="text-lg ">   Single Program $150 [3 month free trial] </span> 
           <br /> 
          <span className="text-lg"> All Four Program $500 [3 month free trial] </span>
        </>
      ),
      // price: "$150",
      // paragraph:

      features: [
        "Support for downloading and set up",
        "Full code access",
        "Access for single purchaser for 12 months $25",
        "Free updates for 2 years.",
      ],
      buttonText: "Purchase Now",
    },
    // {
    //   title: (
    //     <>
    //       Single Program $150 <br />
    //       All Four Program $500
    //     </>
    //   ),

    //   paragraph:
    //     "Use by you or one client in a single end product that is not charged to end users",
    //   features: [
    //     "06 Month Validity",
    //     "Free Lifetime Access to Updates",
    //     "06 Months of Support from us",
    //     "Full source code",
    //     "06 Month Validity",
    //     "Free Lifetime Access to Updates",
    //     "6 Months of Support from us",
    //     "Full source code",
    //   ],
    //   buttonText: "Purchase Now",
    // },
  ];

  return (
    <section className="">
      <div className="text-center mb-10 flex flex-col gap-y-5">
        <h1 className="text-xl lg:text-3xl font-bold">Online License Pricing Options</h1>
        <p className="text-gray-600 text-sm lg:text-base px-3">
          Flexible plans for individual programs or full access to all four
          programs.
        </p>
      </div>

      <div className="flex justify-center items-center ">
        <div className="w-[]">
          {plans.map((plan, index) => (
            <PricingCard key={index} {...plan} />
          ))}
        </div>
      </div>
    </section>
  );
}
